import { readEnv } from "../utils/env-helper.ts";

export interface AppConfigRunTimeEnv {
  BASE_URL: string;
  GATEWAY_URL: string;
  LANGUAGE: string;
  VERSION: string;
  BRANCH: string;
  STAGE: string;
  SUPPORT_MAIL_ADESSO: string;
  SUPPORT_MAIL_BVHI: string;
  ACTIVE_FEATURES: string;
  AVAILABLE_SUPPLIERS_AND_ERP_SUPPLIERS_EMBEDDED_IMAGE_URL: string;
  UPDATED_AGB_CONSENT_DEADLINE: string;
}

export interface AppAppConfig {
  language: string;
  postMessageTimeout: number;
  backgroundProcessingRefetchInterval: number;
  env: {
    baseUrl: string;
    gatewayUrl: string;
    version: string;
    branch: string;
    stage: string;
    supportMailAdesso: string;
    supportMailBVHI: string;
    availableSuppliersAndErpSuppliersEmbeddedImageURL: string;
    updateAGBConsentDeadline: string;
  };
}

const DEFAULT_APP_CONFIG: AppAppConfig = {
  language: readEnv("LANGUAGE", "de"),
  env: {
    baseUrl: readEnv("BASE_URL", ""),
    gatewayUrl: readEnv("GATEWAY_URL", ""),
    version: readEnv("VERSION", ""),
    branch: readEnv("BRANCH", ""),
    stage: readEnv("STAGE", ""),
    supportMailAdesso: readEnv("SUPPORT_MAIL_ADESSO", "support-hidatasync@adesso.de"),
    supportMailBVHI: readEnv("SUPPORT_MAIL_BVHI", "hidatasync@bvhi.org"),
    availableSuppliersAndErpSuppliersEmbeddedImageURL: readEnv("AVAILABLE_SUPPLIERS_AND_ERP_SUPPLIERS_EMBEDDED_IMAGE_URL", ""),
    updateAGBConsentDeadline: readEnv("UPDATED_AGB_CONSENT_DEADLINE", "2026-04-15"),
  },
  postMessageTimeout: 2000,
  backgroundProcessingRefetchInterval: 2000,
};

let appConfig: AppAppConfig = {
  language: DEFAULT_APP_CONFIG.language,
  env: {
    baseUrl: DEFAULT_APP_CONFIG.env.baseUrl,
    gatewayUrl: DEFAULT_APP_CONFIG.env.gatewayUrl,
    version: DEFAULT_APP_CONFIG.env.version,
    branch: DEFAULT_APP_CONFIG.env.branch,
    stage: DEFAULT_APP_CONFIG.env.stage,
    supportMailAdesso: DEFAULT_APP_CONFIG.env.supportMailAdesso,
    supportMailBVHI: DEFAULT_APP_CONFIG.env.supportMailBVHI,
    availableSuppliersAndErpSuppliersEmbeddedImageURL: DEFAULT_APP_CONFIG.env.availableSuppliersAndErpSuppliersEmbeddedImageURL,
    updateAGBConsentDeadline: DEFAULT_APP_CONFIG.env.updateAGBConsentDeadline,
  },
  postMessageTimeout: DEFAULT_APP_CONFIG.postMessageTimeout,
  backgroundProcessingRefetchInterval: DEFAULT_APP_CONFIG.backgroundProcessingRefetchInterval,
};

export function setAppConfig(overrides: Partial<AppAppConfig>) {
  appConfig = {
    ...appConfig,
    ...overrides,
    env: {
      ...appConfig.env,
      ...overrides.env,
    },
  };
}

export function getAppConfig() {
  return appConfig;
}
